module.exports = __webpack_public_path__ + "static/media/create_branch_2.ddc7d675.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/tutorials/create_branch/create_branch_2.png
// module id = 2231
// module chunks = 0